import { render } from "./LoginDialog.vue?vue&type=template&id=2c822932&scoped=true"
import script from "./LoginDialog.vue?vue&type=script&lang=js"
export * from "./LoginDialog.vue?vue&type=script&lang=js"

import "./LoginDialog.vue?vue&type=style&index=0&id=2c822932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c822932"]])

export default __exports__